import React from 'react';
import {
	FontAwesomeIcon,
	type FontAwesomeIconProps,
} from '@fortawesome/react-fontawesome';
import {type TypographyProps} from '@mui/material';
import {type CellContext, type RowData} from '@tanstack/react-table';
import {styled} from '@netx/core-components/Theme';
import {GenericCell} from './GenericCell';

const GenericIconCellRoot = styled('div')(({theme}) => ({
	display: 'flex',
	alignItems: 'center',
}));

const GenericIconCellIcon = styled('div')(({theme}) => ({
	flex: '0 0 auto',
	paddingRight: 8,
	opacity: 0.5,
}));

export interface GenericIconCellProps<
	TData extends RowData,
> extends CellContext<TData, number | string | null> {
	icon: FontAwesomeIconProps['icon'];
	TypographyProps?: Partial<TypographyProps>;
}

export const GenericIconCellPrimitive = <TData extends RowData>({
	row,
	icon,
	...props
}: GenericIconCellProps<TData>) => {
	return (
		<GenericIconCellRoot>
			<GenericIconCellIcon>
				<FontAwesomeIcon icon={icon} fixedWidth />
			</GenericIconCellIcon>
			<GenericCell row={row} {...props} />
		</GenericIconCellRoot>
	);
};

export const GenericIconCell = GenericIconCellPrimitive;

export default GenericIconCell;
